export class ProcExtendProperty {
    /**
     * 设计器扩展属性Id
     */
    id: string;
    /**
     * 扩展属性code
     */
    code: string;
    /**
     * 父级id
     */
    parentId?: string;
    /**
     * 在当前层级的排序
     */
    sortOrder: number;
    /**
     * 扩展属性备注
     */
    propertyNote?: string;
    /**
     * 扩展属性标题
     */
    propertyTitle: string;
    /**
     * 扩展属性位置
     */
    propertyLocation: string;
    /**
     * 扩展属性类型
     */
    propertyType: string;
    /**
     * 枚举型扩展属性的枚举值
     */
    enumValue?: string;
    /**
     * 流程分类id
     */
    bizDefKey?: string;
    /**
     * 业务种类id
     */
    bizCategoryId?: string;
    /**
     * 流程启动方式
     */
    startMode: string;
    /**
     * 扩展属性value
     */
    value?: string;
}